import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router";
import "./PopupModal.css";

const PopupModal = ({
  popupType,
  setpopupType,
  Navigation,
  error,
  Message,
  handleSuccessfalse,
  setIsRefreshed,
  OrderDetails,
  setMessage,
  Active,
}) => {
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSuccessClose = () => {
    if (Navigation) navigate(Navigation);

    setIsRefreshed?.(true);
    handleSuccessfalse?.();
    setpopupType?.("");
    OrderDetails?.(Active);
    setMessage?.("");

    setShowSuccess(false);
  };

  const handleErrorClose = () => {
    setpopupType?.("");
    setMessage?.("");
    setShowError(false);
  };

  useEffect(() => {
    if (!popupType) return;

    if (popupType === "success") {
      setShowSuccess(true);
      setShowError(false);
    } else if (popupType === "error") {
      setShowError(true);
      setShowSuccess(false);
    }
  }, [popupType]);

  return (
    <>
      <Modal show={showSuccess} onHide={handleSuccessClose}>
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="success-icon-new">
            <svg width="80" height="80" viewBox="0 0 80 80">
              <circle className="popoup-modal-circle" cx="40" cy="40" r="35" />
              <path className="tick" d="M22 40 L34 52 L58 28" />
            </svg>
          </div>

          <h5 className="successmsg">
            {Message || "Record Added Successfully !"}
          </h5>
        </Modal.Body>

        <Modal.Footer>
          <button className="success-button" onClick={handleSuccessClose}>
            Ok
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showError} onHide={handleErrorClose}>
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="error-icon-new">
            <svg width="80" height="80" viewBox="0 0 80 80">
              <circle className="circle" cx="40" cy="40" r="35" />
              <path className="cross cross1" d="M28 28 L52 52" />
              <path className="cross cross2" d="M52 28 L28 52" />
            </svg>
          </div>

          <h5 className="errormsg">
            {error || "Something went wrong, Please try again !"}
          </h5>
        </Modal.Body>

        <Modal.Footer>
          <button className="error-button" onClick={handleErrorClose}>
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export { PopupModal };
